// src/components/ErrorBoundary.js
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // Update state so the next render shows the fallback UI.
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  // Log error details if needed.
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    // Optionally log error info to an external service here.
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <>
        <div className="main-container">
          <h1>Something went wrong.</h1>
          <br />
          <button className={"retry-button"} onClick={() => {
            window.location.reload();
          }}>
            🔄 Reload the Page and Try Again!
          </button>
          <br /><br />
        </div>
      </>
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
